var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaEnkeltRedHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.594,
    height: 26.838,
    viewBox: "0 0 28.594 26.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shop",
    d: "M5.215,1.615A1.756,1.756,0,0,1,6.549,1H21.544a1.756,1.756,0,0,1,1.335.615L27.46,6.959a2.634,2.634,0,0,1,.634,1.714v.448a4.17,4.17,0,0,1-7.462,2.56,4.171,4.171,0,0,1-6.584,0,4.171,4.171,0,0,1-6.584,0A4.17,4.17,0,0,1,0,9.121V8.673A2.634,2.634,0,0,1,.634,6.959L5.217,1.613ZM8.34,9.121a2.414,2.414,0,0,0,4.829,0,.878.878,0,0,1,1.756,0,2.414,2.414,0,1,0,4.829,0,.878.878,0,1,1,1.756,0,2.414,2.414,0,0,0,4.829,0V8.673a.878.878,0,0,0-.211-.571L21.544,2.756H6.549L1.967,8.1a.878.878,0,0,0-.211.571v.448a2.414,2.414,0,0,0,4.829,0,.878.878,0,0,1,1.756,0ZM2.634,14.169a.878.878,0,0,1,.878.878V25.582H5.268V16.8a1.756,1.756,0,0,1,1.756-1.756h5.268A1.756,1.756,0,0,1,14.047,16.8v8.779H24.582V15.047a.878.878,0,0,1,1.756,0V25.582h.878a.878.878,0,0,1,0,1.756H.878a.878.878,0,1,1,0-1.756h.878V15.047A.878.878,0,0,1,2.634,14.169Zm4.39,11.413h5.268V16.8H7.023ZM15.8,16.8a1.756,1.756,0,0,1,1.756-1.756H21.07A1.756,1.756,0,0,1,22.826,16.8V22.07a1.756,1.756,0,0,1-1.756,1.756H17.559A1.756,1.756,0,0,1,15.8,22.07Zm5.268,0H17.559V22.07H21.07Z",
    transform: "translate(0.25 -0.75)",
    fill: "#ff1e56",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaEnkeltRedHome);
export default __webpack_public_path__ + "static/media/sa-enkelt-red-home.ed822b9ba1b67dfcaba7a6da93eb9f82.svg";
export { ForwardRef as ReactComponent };